import { DropdownItem, DropdownMenu, DropdownToggle, NavItem, NavbarBrand, UncontrolledDropdown } from "reactstrap";
import { getLogoLing } from "./menubarHelper";
import { NavLink, useLocation } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiAccountCircle } from "@mdi/js";
import Avatar from "react-avatar";
import Notifications from "../Notifications/Notifications";
import AttendeeChatNotifications from "../Notifications/AttendeeChatNotifications";
import { useEffect, useState } from "react";

/*
    - MENUBAR LOGO COMPONENT
*/
export function NavbarLogo() {

    /* GET LOG LINK BASED ON THE WEBCONFIG */
    const logoLink = getLogoLing();

    if (global.$header?.logo != "") {
        return (
            <NavbarBrand href={`${logoLink}`} target="_self">
                <img className="menulogo" src={global.$header.logo} />
            </NavbarBrand>
        )
    }

}

/*
    - MENUBAR LINK COMPONENT
*/
export function MenuBarItem({ menuItem, menuItemObject, login }) {

    const location = useLocation();

    /* home page link condtion */
    if (menuItem == 'home') {
        return (<HomePageLinkItem menuItemObject={menuItemObject} />)
    }


    /* 
        - RENDER MenuDropDown COMPONENT IF 'dropdown' IS INCLUDED IN menuItem
    */
    if (menuItem.includes('dropdown')) {
        return (
            <MenuDropDown menuItemObject={menuItemObject} login={login} />
        )
    }

    /* 
        - NOTIFICATION COMPONENT - NOTTE: NOT WORKING PACKAGE ISSUE
    */

    if (menuItem === "notifications") {
        if (login) {
            return (
                <Notifications />
            );
        }
        return null;
    }

    /* 
        - NOTIFICATION COMPONENT - NOTTE: NOT WORKING PACKAGE ISSUE
    */
    if (menuItem == "chatnotifications") {
        if (login) {
            return (
                <AttendeeChatNotifications />
            )
        }
        return null;
    }

    /* 
        - AFTER LOGIN CLICK ANY LINK THAT REDIRECT TO THE LOGIN PAGE
    */
    if (
        login &&
        menuItem?.showmenubeforloginandredirecttologin == "Y"
    ) {
        return (navItem(menuItemObject, "/LoginForm", location))
    }


    /* 
        - AFTER LOGIN LINKS 
        - If the menuItemObject requires login and the global login status is 'true', render the NavLink
    */
    if (login) {
        

        if (menuItem.includes('html') && menuItemObject.login == 'Y') {
            return (
                <NavItem>
                    <NavLink
                        to={`/${menuItem}`}
                        active={location.pathname === menuItemObject.link}
                        style={{
                            color: menuItemObject?.styles?.color ?
                                menuItemObject?.styles?.color : global.menutextcolor
                        }}
                        key={menuItemObject.link}
                    >
                        {menuItemObject.title}
                    </NavLink>
                </NavItem>)
        }

        /*
            - 
         */
        if (menuItemObject.usertype) {
            const configUsertypes = menuItemObject.usertype.split(";");
            const userTypes = global.$userstype && global.$userstype !== "" ? global.$userstype.split(",") : [];
            const isUserTypeMatch = userTypes.some(userType => configUsertypes.includes(userType));

            if (isUserTypeMatch) {
                return (navItem(menuItemObject, menuItemObject?.link, location, login))
            }
            return null;
        }
        return (navItem(menuItemObject, menuItemObject?.link, location, login))

    }

    /*
        - If the menuItemObject does not require login and the global login status is 'false', render the NavLink
    */
    if (menuItemObject.login == 'N') {
        return (navItem(menuItemObject, menuItemObject?.link, location, login))
    }

    if (menuItemObject.login == null) {
        return (navItem(menuItemObject, menuItemObject?.link, location, login))
    }
}

/*
    - COMMON LINK BUTTON FUNCTION
*/
function navItem(menuItemObject, tolink, location, login) {

    let title = menuItemObject?.title

    if (login) {
        if (menuItemObject?.titleafterlogin) {
            title = menuItemObject?.titleafterlogin
        }
    }
    return (
        <NavItem>
            <NavLink
                to={`${tolink}`}
                active={location.pathname === menuItemObject?.link}
                style={{
                    ...menuItemObject.styles,
                    color: menuItemObject?.styles?.color ?
                        menuItemObject?.styles?.color : global.menutextcolor
                }}
            >
                {title}
            </NavLink>
        </NavItem>
    )
}


/*
    - MENUBAR LINK DROPDOWN COMPONENT
*/
function MenuDropDown({ menuItemObject, login }) {

    const location = useLocation()

    let items = [];
    items.push(
        menuItemObject.item1,
        menuItemObject.item2,
        menuItemObject.item3,
        menuItemObject.item4,
        menuItemObject.item5
    )

    const dropdown = <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret style={{ color: global.menutextcolor }}>
            {menuItemObject.title}
        </DropdownToggle>
        <DropdownMenu right>
            {
                items.map((item) => {

                    if (item.title == 'empty') {
                        return null
                    }

                    if (item.login == 'Y' && login) {
                        return (
                            <DropdownItem>
                                <NavLink
                                    to={`${item.link}`}
                                    active={location.pathname === item.link}
                                    style={global.$dropdown1.item1.style}
                                    className={'dropdown-menuitem'}
                                    key={item}
                                >
                                    {item.title}
                                </NavLink>
                            </DropdownItem>
                        )
                    }

                    if (item.login == 'N') {
                        return (
                            <DropdownItem>
                                <NavLink
                                    to={`${item.link}`}
                                    active={location.pathname === item.link}
                                    style={global.$dropdown1.item1.style}
                                    className={'dropdown-menuitem'}
                                    key={item}
                                >
                                    {item.title}
                                </NavLink>
                            </DropdownItem>
                        )
                    }


                })
            }
        </DropdownMenu>
    </UncontrolledDropdown>

    if (menuItemObject.login == 'Y' && login) {
        return (dropdown)
    }

    if (menuItemObject.login == 'N') {
        return (dropdown)
    }

}

/*
    - HOME PAGE LINK ITEM COMPONENT
*/
function HomePageLinkItem({ menuItemObject }) {

    // Get the current location using react-router's useLocation hook
    const location = useLocation();

    // Set the default value for loginHome
    let loginHome = "home";

    // Check if user is logged in and has a specific login home route
    if (global.$loginstatus === "true" && global.$login.loginhome !== null && global.$login.loginhome !== "") {
        loginHome = "loginsuccess";
    }

    // Common properties for NavLink
    const commonProps = {
        to: loginHome === "home" ? '/home' : '/LoginHome',  // Ternary operator to set the 'to' prop based on loginHome value
        active: location.pathname === menuItemObject?.link, // Check if the NavLink is active based on the current location
        style: { color: global.menutextcolor } // Set the text color based on the global configuration
    };

    // Check conditions for rendering NavLink and choose appropriate title
    if (loginHome === "home" || !global.$header.menu.home?.titleafterlogin) {
        // If loginHome is 'home' or there is no titleafterlogin, use default title
        const title = global.$header.menu.home?.title || 'HOME';

        return (
            <NavItem>
                {/* Render NavLink with common properties */}
                <NavLink {...commonProps}>
                    {title}
                </NavLink>
            </NavItem>
        );
    }

    // If there is a titleafterlogin, render NavLink with that title
    return (
        <NavItem>
            {/* Render NavLink with common properties */}
            <NavLink {...commonProps}>
                {global.$header.menu.home.titleafterlogin}
            </NavLink>
        </NavItem>
    );
}

/*
    - PROFILE BUTTON FUNCTION
]*/
export function ProfileIconAndLogin() {

    const location = useLocation();

    if (global.$loginstatus.includes('false')) {
        return (
            <NavItem>
                <NavLink
                    to={`/LoginForm`}
                    active={location.pathname === '/LoginForm'}
                    style={{ ...global.$header.login.styles }}
                    className={'login-button-link'}
                >
                    {global.$header.login.title}
                </NavLink>
            </NavItem>
        )
    }
    else {
        return (
            <UncontrolledDropdown nav inNavbar className="profile-menubar-wrapper">
                <DropdownToggle nav caret>
                    <Icon
                        path={mdiAccountCircle}
                        size={1}
                        className="menubar-icons"
                        style={{ color: global.menutextcolor }}
                    //style={global.profileiconstyles} // NOTE: error
                    />
                </DropdownToggle>
                <DropdownMenu right>
                    {/* profile dropdown image or Avatar image */}
                    {
                        global.$imageUrl &&
                            (global.$imageUrl.includes("common_profile") ||
                                global.$imageUrl == "-1" ||
                                global.$imageUrl == "" ||
                                global.$imageUrl == " ") ?

                            <div className="menu-avatar_wrapper">
                                <Avatar
                                    className="menu-avatar"
                                    name={`${global.$fname + " " + global.$lname}`}
                                />
                            </div> :

                            <div className="menu-avatar_wrapper">
                                <img
                                    src={global.$imageUrl}
                                    style={global.$profile.photo.imgstyles}
                                    className="menu-avatar"
                                />
                            </div>

                    }

                    {/* profile dropdown user full name */}
                    <DropdownItem divider />
                    <p className="menu-profile-name">
                        <b>{`${global.$fname} ${global.$lname}`}</b>
                    </p>

                    {/* profile dropdown navigation to profile page */}
                    <DropdownItem>
                        <NavLink
                            to="/ProfileTabs"
                            active={location.pathname === '/ProfileTabs'}
                            className={'dropdown-menuitem'}
                        >
                            Profile
                        </NavLink>
                    </DropdownItem>


                    <DropdownItem divider />
                    <DropdownItem>
                        <NavLink
                            to="/Logout"
                            active={location.pathname === '/Logout'}
                            className={'dropdown-menuitem'}
                        >
                            Logout
                        </NavLink>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        )
    }


}